import React from "react";
import styled from "styled-components";
import { Stack } from "react-bootstrap";
import { useMemo } from "react";
import { DetalleVenta } from "../../services/ventasServicios";
import DetallesVentaTable from "../pages/HistorialVentas/DetallesVentaTable";

function DetailsTableSection({ detalles }: { detalles: DetalleVenta[] }) {
  const items = useMemo(() => {
    let detallesOrdenados = detalles;
    detallesOrdenados.sort((itemA, itemB) => {
      return itemB.cantidad * itemB.valor - itemA.cantidad * itemA.valor;
    });
    return detallesOrdenados;
  }, [detalles]);

  return (
    <ResponsiveTableSection>
      <TableWrapper>
        <Stack gap={4}>
          <DetallesVentaTable items={items} />
        </Stack>
      </TableWrapper>
    </ResponsiveTableSection>
  );
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

export default DetailsTableSection;
